import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import React from 'react'

const SimpleIcon = ({ icon, className = '' }) => (
  <span className={`fa-layers fa-fw ${className}`}>
    <FontAwesomeIcon icon={icon} />
  </span>
)

SimpleIcon.propTypes = {
  icon: PropTypes.object.isRequired,
  className: PropTypes.string
}

export default SimpleIcon
